import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished, loadingFailed } from "@itk/typescript-utils";
import { Model_QuickSearchGet, Model_QuickSearchPost } from "src/backend/openapi/v1";

export enum Action {
  GlobalSearchRequest = "@@ITK:SRC:COMPONENTS:APPLICATION-WRAPPER:COMPONENTS:GLOBAL-SEARCH:GLOBAL-SEARCH-STORE.TS:ACTION:GLOBALSEARCHREQUEST",
  GlobalSearchSuccess = "@@ITK:SRC:COMPONENTS:APPLICATION-WRAPPER:COMPONENTS:GLOBAL-SEARCH:GLOBAL-SEARCH-STORE.TS:ACTION:GLOBALSEARCHSUCCESS",
  GlobalSearchFail = "@@ITK:SRC:COMPONENTS:APPLICATION-WRAPPER:COMPONENTS:GLOBAL-SEARCH:GLOBAL-SEARCH-STORE.TS:ACTION:GLOBALSEARCHFAIL",
  GlobalSearchReset = "@@ITK:SRC:COMPONENTS:APPLICATION-WRAPPER:COMPONENTS:GLOBAL-SEARCH:GLOBAL-SEARCH-STORE.TS:ACTION:GLOBALSEARCHRESET",

  Clear = "@@ITK:SRC:COMPONENTS:APPLICATION-WRAPPER:COMPONENTS:GLOBAL-SEARCH:GLOBAL-SEARCH-STORE.TS:ACTION:CLEAR"
}

type globalSearchState = {
  globalSearchState: Loading<Model_QuickSearchGet[]>;
};

const initialState: globalSearchState = {
  globalSearchState: loadingNotStarted
};

export const globalSearchActions = {
  globalSearchRequest: (data: Model_QuickSearchPost) => actionCreator(Action.GlobalSearchRequest, { data }),
  globalSearchSuccess: (data: Model_QuickSearchGet[]) => actionCreator(Action.GlobalSearchSuccess, { data }),
  globalSearchFail: () => actionCreator(Action.GlobalSearchFail),
  globalSearchReset: () => actionCreator(Action.GlobalSearchReset),

  clear: () => actionCreator(Action.Clear)
};

export const globalSearchReducer = (state = initialState, action: ActionReturnType<typeof globalSearchActions>): globalSearchState => {
  switch (action.type) {
    case Action.GlobalSearchRequest:
      return { ...state, globalSearchState: loadingIsLoading };
    case Action.GlobalSearchSuccess:
      return { ...state, globalSearchState: loadingFinished(action.payload.data) };
    case Action.GlobalSearchFail:
      return { ...state, globalSearchState: loadingFailed };
    case Action.GlobalSearchReset:
      return { ...state, globalSearchState: loadingNotStarted };

    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
